import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ZipCodeService extends BaseService {

  PATH_OF_API = environment.BaseApiUrl;

  constructor(public httpClient: HttpClient, authService: AuthService) {
    super(authService);
  }

  //zip code 
  public getDetailByZip(zipCode: any) {
    return this.httpClient.get(this.baseUrl + '/Customer/zipCode?countryCode='+'US'+ '&zipCode=' + zipCode,
      this.headerWithToken()).pipe(map(res => res));
  }

  //zip for pay link
  public getDetailByZipPayment(zipCode: any) {
    const PaymentToken = this.authService.getPayToken();
    return this.httpClient.get(this.baseUrl + '/Customer/zipCode?countryCode='+'US'+ '&zipCode=' + zipCode,
      this.headerWithTokenPayment(PaymentToken)).pipe(map(res => res));
  }
}
